import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCar, FaCouch, FaCheck, FaArrowRight, FaCommentAlt, FaCalculator, FaEuroSign, FaMapMarkerAlt } from 'react-icons/fa';
import TrustMap from '../components/TrustMap';
import './TarifsPage.css';

// Quote Calculator Component
const QuoteCalculator = () => {
    const [category, setCategory] = useState('voiture');
    const [type, setType] = useState('citadine');
    const [formula, setFormula] = useState('premium');

    const pricing = {
        voiture: {
            citadine: { standard: 60, premium: 90, prestige: 140 },
            berline: { standard: 75, premium: 110, prestige: 170 },
            suv: { standard: 90, premium: 130, prestige: 195 }
        },
        mobilier: {
            fauteuil: { unique: 45 },
            'canape-2': { unique: 70 },
            'canape-3': { unique: 95 },
            'matelas-1': { unique: 45 },
            'matelas-2': { unique: 75 }
        }
    };

    const calculatePrice = () => {
        if (category === 'voiture') {
            return pricing.voiture[type][formula];
        }
        return pricing.mobilier[type].unique;
    };

    return (
        <div className="calculator-wrapper">
            <div className="calc-card">
                <div className="calc-header">
                    <FaCalculator className="calc-icon" />
                    <h3>Estimateur de Tarif</h3>
                </div>

                <div className="calc-body">
                    <div className="calc-step">
                        <label>Votre besoin :</label>
                        <div className="calc-options">
                            <button
                                className={`opt-btn ${category === 'voiture' ? 'active' : ''}`}
                                onClick={() => { setCategory('voiture'); setType('citadine'); }}
                            >
                                Véhicule
                            </button>
                            <button
                                className={`opt-btn ${category === 'mobilier' ? 'active' : ''}`}
                                onClick={() => { setCategory('mobilier'); setType('canape-2'); }}
                            >
                                Mobilier
                            </button>
                        </div>
                    </div>

                    <div className="calc-step">
                        <label>{category === 'voiture' ? 'Taille du véhicule :' : 'Type de mobilier :'}</label>
                        <select value={type} onChange={(e) => setType(e.target.value)}>
                            {category === 'voiture' ? (
                                <>
                                    <option value="citadine">Citadine (Fiat 500, Clio...)</option>
                                    <option value="berline">Berline / Break (Audi A4, Tesla...)</option>
                                    <option value="suv">SUV / 4x4 / Familiale</option>
                                </>
                            ) : (
                                <>
                                    <option value="fauteuil">Fauteuil</option>
                                    <option value="canape-2">Canapé 2 places</option>
                                    <option value="canape-3">Canapé 3 places / Angle</option>
                                    <option value="matelas-1">Matelas 1 personne</option>
                                    <option value="matelas-2">Matelas 2 personnes</option>
                                </>
                            )}
                        </select>
                    </div>

                    {category === 'voiture' && (
                        <div className="calc-step">
                            <label>Formule souhaitée :</label>
                            <div className="calc-options secondary">
                                <button
                                    className={`opt-btn sm ${formula === 'standard' ? 'active' : ''}`}
                                    onClick={() => setFormula('standard')}
                                >
                                    Standard
                                </button>
                                <button
                                    className={`opt-btn sm ${formula === 'premium' ? 'active' : ''}`}
                                    onClick={() => setFormula('premium')}
                                >
                                    Premium
                                </button>
                                <button
                                    className={`opt-btn sm ${formula === 'prestige' ? 'active' : ''}`}
                                    onClick={() => setFormula('prestige')}
                                >
                                    Prestige
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div className="calc-footer">
                    <div className="price-display">
                        <span className="price-label">Estimation :</span>
                        <div className="price-value">
                            <span>à partir de</span>
                            <strong>{calculatePrice()}<FaEuroSign className="euro-sm" /></strong>
                        </div>
                    </div>
                    <Link 
                        to="/reservation" 
                        state={{ 
                            category: category, 
                            type: category === 'voiture' ? (type === 'citadine' ? 'Citadine' : (type === 'berline' ? 'Berline' : 'SUV / Monospace')) : 'Mobilier',
                            mobilierCat: category === 'mobilier' ? (type.includes('canape') ? 'canapes' : (type.includes('matelas') ? 'matelas' : 'autres')) : 'canapes',
                            prestation: category === 'voiture' ? 
                                `${formula === 'standard' ? 'PROPRETÉ STANDARD' : (formula === 'premium' ? 'PROPRETÉ PREMIUM' : 'PROPRETÉ PRESTIGE')} - ${type === 'citadine' ? 'Citadine' : (type === 'berline' ? 'Berline' : 'SUV / Monospace')}` :
                                (type === 'fauteuil' ? 'CHAISES / FAUTEUILS' : 
                                 type === 'canape-2' ? 'CANAPÉ 2 PLACES' : 
                                 type === 'canape-3' ? 'CANAPÉ 3 PLACES' : 
                                 type === 'matelas-1' ? '1 PLACE (90cm)' : 
                                 '2 PLACES (140/160cm)')
                        }}
                        className="btn btn-primary full-width"
                    >
                        Réserver maintenant
                    </Link>
                </div>
            </div>
            <p className="calc-disclaimer">* Tarifs donnés à titre indicatif selon l'état du support.</p>
        </div>
    );
};

const TarifsPage = () => {

    return (
        <div className="prestations-page-wrapper">
            <section className="selection-trigger-section">
                <div className="container">
                    <div className="selector-header center">
                        <span className="premium-label">GRILLE TARIFAIRE</span>
                        <h2 className="section-title">NOS <span className="text-gradient-blue">TARIFS</span></h2>
                    </div>

                    <div className="intro-content-premium text-center">
                        <span className="intro-badge-premium">TRANSPARENCE ET QUALITÉ</span>
                        <h3 className="sub-header-premium">Le juste prix pour un résultat <span className="text-gradient-blue">d'exception</span></h3>
                        <div className="intro-underline"></div>
                        <p className="description-text-premium">
                            Retrouvez ci-dessous nos grilles tarifaires pour le nettoyage automobile et l'entretien de vos mobiliers.
                            Le déplacement est <strong>offert</strong> dans un rayon de 20km autour de Meulan.
                        </p>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="tarif-content-section">
                <div className="container">
                    {/* Pricing Grid (Cards) */}
                    <div className="pricing-grid">
                        {/* Automobile Card */}
                        <div className="pricing-card">
                            <div className="card-header">
                                <div className="icon-wrapper blue-glow">
                                    <FaCar />
                                </div>
                                <div className="header-text-box">
                                    <h3>Automobile</h3>
                                    <p className="card-subtitle">Nettoyage complet & options</p>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="price-tag">
                                    <span className="from">à partir de</span>
                                    <span className="amount">50€</span>
                                </div>
                                <ul className="feature-list">
                                    <li><FaCheck className="check-icon" /> Citadine</li>
                                    <li><FaCheck className="check-icon" /> Berline / SUV</li>
                                    <li><FaCheck className="check-icon" /> Monospace / 4x4</li>
                                    <li><FaCheck className="check-icon" /> Options pressing disponibles</li>
                                </ul>
                            </div>

                            <div className="card-footer">
                                <Link to="/nettoyage-voiture" className="card-btn">
                                    Voir les détails <FaArrowRight />
                                </Link>
                            </div>
                        </div>

                        {/* Furniture Card */}
                        <div className="pricing-card popular">
                            <div className="popular-tag">Populaire</div>
                            <div className="card-header">
                                <div className="icon-wrapper orange-glow">
                                    <FaCouch />
                                </div>
                                <div className="header-text-box">
                                    <h3>Mobiliers</h3>
                                    <p className="card-subtitle">Redonnez vie à votre intérieur</p>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="price-tag">
                                    <span className="from">à partir de</span>
                                    <span className="amount">40€</span>
                                </div>
                                <ul className="feature-list">
                                    <li><FaCheck className="check-icon" /> Canapés (tous textiles)</li>
                                    <li><FaCheck className="check-icon" /> Matelas & Tapis</li>
                                    <li><FaCheck className="check-icon" /> Chaises & Fauteuils</li>
                                    <li><FaCheck className="check-icon" /> Désinfection incluse</li>
                                </ul>
                            </div>

                            <div className="card-footer">
                                <Link to="/nettoyage-mobiliers" className="card-btn primary">
                                    Voir les détails <FaArrowRight />
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Detailed Pricing Grid Section */}
                    <div className="detailed-pricing-grid-section">
                        <div className="section-header-modern">
                            <span className="section-badge">Barème complet</span>
                            <h2>Grilles détaillées des prestations</h2>
                            <div className="header-underline"></div>
                        </div>

                        <div className="pricing-tables-container">
                            {/* Automobile Table */}
                            <div className="pricing-table-glass">
                                <div className="table-header">
                                    <FaCar className="table-icon" />
                                    <h3>Nettoyage Automobile</h3>
                                </div>
                                <div className="table-wrapper">
                                    <table className="pricing-data-table">
                                        <thead>
                                            <tr>
                                                <th>Catégorie</th>
                                                <th>Standard</th>
                                                <th>Premium</th>
                                                <th>Prestige</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Citadine / Compacte</td>
                                                <td className="price-cell">50€</td>
                                                <td className="price-cell">70€</td>
                                                <td className="price-cell prestige">100€</td>
                                            </tr>
                                            <tr>
                                                <td>Berline / Mini SUV</td>
                                                <td className="price-cell">60€</td>
                                                <td className="price-cell">80€</td>
                                                <td className="price-cell prestige">110€</td>
                                            </tr>
                                            <tr>
                                                <td>SUV / Monospace</td>
                                                <td className="price-cell">70€</td>
                                                <td className="price-cell">90€</td>
                                                <td className="price-cell prestige">120€</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-footer-note">
                                    <p>* Supplément de 15€ : poils d'animaux, sable ou véhicule très sale.</p>
                                </div>
                            </div>

                            {/* Furniture Table */}
                            <div className="pricing-table-glass">
                                <div className="table-header">
                                    <FaCouch className="table-icon" />
                                    <h3>Nettoyage Mobilier</h3>
                                </div>
                                <div className="table-wrapper">
                                    <table className="pricing-data-table furniture-table">
                                        <thead>
                                            <tr>
                                                <th>Prestation</th>
                                                <th>Tarif estimé</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Canapé 2 places</td>
                                                <td className="price-cell">80€</td>
                                            </tr>
                                            <tr>
                                                <td>Canapé 3 places</td>
                                                <td className="price-cell">90€</td>
                                            </tr>
                                            <tr>
                                                <td>Canapé 4/5 places</td>
                                                <td className="price-cell">110€</td>
                                            </tr>
                                            <tr>
                                                <td>Canapé 5/6 places</td>
                                                <td className="price-cell">120€</td>
                                            </tr>
                                            <tr>
                                                <td>Matelas (Simple / Double)</td>
                                                <td className="price-cell">dès 40€</td>
                                            </tr>
                                            <tr>
                                                <td>Chaise / Fauteuil</td>
                                                <td className="price-cell">dès 10€</td>
                                            </tr>
                                            <tr>
                                                <td>Tapis / Moquette</td>
                                                <td className="price-cell italic-text">Sur devis</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Zone d'Intervention Map */}
            <TrustMap />

            {/* Pricing Footer CTA */}
            <section className="tarif-footer-cta">
                <div className="container">
                    <div className="cta-box-modern">
                        <div className="cta-icon-wrapper">
                            <FaCommentAlt />
                        </div>
                        <div className="cta-text-content">
                            <h3>Prêt à franchir le pas ?</h3>
                            <p>Choisissez l'excellence pour votre véhicule ou votre mobilier. Nous nous occupons de tout.</p>
                        </div>
                        <Link to="/reservation" className="btn btn-primary">
                            Réserver maintenant <FaArrowRight />
                        </Link>
                    </div>
                </div>
            </section>

            {/* Simulator Section at the bottom */}
            <section className="tarif-simulator-section">
                <div className="container">
                    <div className="quote-calculator-section-tarif">
                        <div className="calc-layout">
                            <div className="calc-info-text">
                                <span className="section-label">Tarification</span>
                                <h2 className="section-title">Une offre transparente</h2>
                                <p className="about-text">
                                    Chez RoulezPropre, pas de mauvaise surprise. Utilisez notre simulateur pour obtenir une estimation immédiate pour votre véhicule ou votre mobilier.
                                </p>
                                <ul className="calc-features">
                                    <li><FaCheck className="check-icon" /> Déplacement inclus (Secteur Meulan)</li>
                                    <li><FaCheck className="check-icon" /> Produits éco-responsables inclus</li>
                                    <li><FaCheck className="check-icon" /> Facture pro par email</li>
                                </ul>
                            </div>
                            <QuoteCalculator />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TarifsPage;
